import get from 'lodash/get';

export const test = '';

export const getContinueState = (state, sectionIndex, currentBreadcrumbId) => {
  const { questions } = state;
  const currentSection = questions.sections[currentBreadcrumbId];
  if (currentSection && currentSection.length) {
    const currentQuestions = currentSection[sectionIndex];
    const { enableContinue, completed } = currentQuestions || {};
    return {
      enableContinue,
      completed,
    };
  }
  return {
    enableContinue: false,
    completed: false,
  };
};

export const getPopupQuestions = (state) => {
  const { questions } = state;
  return get(questions, 'popupQuestions', []);
};

export const getEnableAdd = (
  state,
  sectionIndex,
  currentBreadcrumbId,
  requiredListQIds = [],
  listQuestionIds = [],
) => {
  const { questions } = state;
  const currentSection = questions.sections[currentBreadcrumbId];
  if (!currentSection) {
    return false;
  }
  const currentQuestions = currentSection[sectionIndex];
  if (!currentQuestions) return false;
  const { answersArray, errorsArray } = currentQuestions;
  /*
		Fixed as part of 6b & 6c under https://sureify.atlassian.net/browse/AM-3307
		1) enableAdd = false; if any of the list questions are invalid even if they are not required
		2) enableAdd = true; if other questions which are not in list are invalid (handled by enableContinue)
	*/
  let _qIds = requiredListQIds;
  if (errorsArray.length) {
    const _eQs = errorsArray.filter((eQ) => listQuestionIds.includes(eQ.question_id));
    if (_eQs.length) {
      _qIds = listQuestionIds;
    }
  }
  const enableAdd =
    requiredListQIds &&
    errorsArray.filter((e) => _qIds.includes(e.question_id)).length === 0 &&
    requiredListQIds.every((id) =>
      answersArray.find((ans) => ans.question_id === id && (ans.answer || ans.answer === 0)),
    );
  return enableAdd;
};

export const getLoaders = (state) => {
  const { questions } = state;
  const { loadingSection, isLoading } = questions;
  return { loadingSection, isLoading };
};

export const getEnableContinueBreadCrumb = (state, currentBreadcrumbId, mode) => {
  if (mode === 'listEdit') {
    return false;
  }
  const { questions, nList } = state;
  const { requiredSchema, enableAdd } = nList;
  const currentSection = questions.sections[currentBreadcrumbId];
  const enableContinue =
    currentSection &&
    currentSection.length &&
    currentSection.reduce((acc, section) => acc && section.enableContinue, true);
  if (requiredSchema.length) {
    return enableAdd && enableContinue;
  }
  return enableContinue;
};
